import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { useDocumentData } from "react-firebase-hooks/firestore";
import JoinChat from "./JoinChat";
import Avatar from "react-avatar";

const Post = (props) => {
  let postData;

  const [joinChatToggle, setJoinChatToggle] = useState();

  const [postInfo] = useDocumentData(
    firebase.firestore().doc(`posts/${props.postId}`)
  );

  if (postInfo) {
    postData = postInfo;
  } else if (props.resultPost) {
    postData = props.resultPost;
  }

  const deletePost = useCallback(() => {
    firebase.firestore().doc(`posts/${props.postId}`).delete();

    const decrement = firebase.firestore.FieldValue.increment(-1);
    firebase.firestore().doc(`gamesList/${postData.id_gamesList}`).update({
      nbr_posts: decrement,
    });
  }, [props.postId, postData]);

  const modifyPost = useCallback(() => {
    props.setNewPostTrigger(true);
    props.setPostValue(postInfo);
  }, [props, postInfo]);

  const registerToggle = useCallback(() => {
    props.setAuthFormTrigger(true);
    props.setLogInTrigger(true);
  }, [props]);

  return (
    <>
      {postData && (
        <li className="posts__el">
          <div className="posts__top">
            <div className="posts__user">
              {props.disconnected ? (
                <>
                  <Avatar
                    className="posts__imgProfil"
                    name={postData.pseudo_user}
                    size="3rem"
                    round="100%"
                  />
                  <div>
                    <span
                      className="posts__pseudo"
                      title="Vous devez être connecté pour voir ce profil"
                    >
                      {postData.pseudo_user}
                    </span>
                    <span className="posts__date">
                      Posté le {postData.date}{" "}
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <Link
                    className="posts__imgProfil"
                    to={`/app/profil/${postData.id_user}`}
                  >
                    <Avatar
                      name={postData.pseudo_user}
                      size="3rem"
                      round="100%"
                    />
                  </Link>

                  <div>
                    <Link
                      to={`/app/profil/${postData.id_user}`}
                      className="posts__pseudo"
                      title="Voir le profil"
                    >
                      {postData.pseudo_user}
                    </Link>
                    <span className="posts__date">
                      Posté le {postData.date}{" "}
                    </span>
                  </div>
                </>
              )}
            </div>
            {!props.searchBool && (
              <div className="posts__btnOpt">
                <button
                  onClick={() => modifyPost()}
                  className="posts__btnModify"
                >
                  Modifier
                </button>
                <button
                  onClick={() => deletePost()}
                  className="posts__btnDelete"
                >
                  Supprimer
                </button>
              </div>
            )}
          </div>

          <div className="posts__filtres">
            {/* <div className="posts__imgGame">
              <img
                src={require(`../../../assets/img/${postData.game_vignette}`)}
                alt="Jeu"
              />
            </div> */}

            <span>{postData.game} </span>
            <span>{postData.platform}</span>
            <span>{postData.level}</span>
          </div>

          <div className="posts__text">
            <p>{postData.description}</p>
          </div>
          <div className="posts__bottom">
            <span className="posts__nbrJoin">
              {postData.user_nbr} personne
              {postData.user_nbr > 1 ? "s ont " : " a "}
              rejoint
            </span>
            {props.disconnected ? (
              <button
                title="Vous devez être connecté pour rejoindre"
                className="posts__btnJoin posts__btnJoin--disabled"
                onClick={() => registerToggle()}
              >
                Rejoindre
              </button>
            ) : (
              <button
                onClick={() => setJoinChatToggle(true)}
                className="posts__btnJoin"
              >
                Rejoindre
              </button>
            )}
          </div>
        </li>
      )}

      {joinChatToggle && (
        <JoinChat
          valueUserInfo={props.valueUserInfo}
          userId={props.userId}
          id_chat={postData.id_chat}
          postId={postData.id}
        />
      )}
    </>
  );
};

export default Post;
